export const GET_AUTH_USER = {
  START: "AUTH/GET_AUTH_USER_START",
  SUCCESS: "AUTH/GET_AUTH_USER_SUCCESS",
  ERROR: "AUTH/GET_AUTH_USER_ERROR",
  CLEAR: "AUTH/CLEAR_AUTH_USER",
};
